import { createSelector } from '@reduxjs/toolkit';
import { selectModel } from '../../store/selectors';

export const selectDetailsState = createSelector(selectModel, (modelState) => modelState.modelDetails);
export const selectModelDetails = createSelector(selectDetailsState, (listState) => listState.modelDetails);
